import { Component, Input, OnInit, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { IScheduledCampaign } from '../../data/interfaces/scheduled-campaign.interface';
import { CHANNEL_ICONS, CHANNEL_STATUS_COLORS } from '../../data/constants/campaigns.constants';
import { CampaignService } from '../../data/services/view/campaign.service';

@Component({
  selector: 'app-campaign-progress',
  templateUrl: './campaign-progress.component.html',
  styleUrls: ['./campaign-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignProgressComponent implements OnInit {
  @Input() campaign: IScheduledCampaign | null = null;

  channelIcons = CHANNEL_ICONS;
  channelStatusColors = CHANNEL_STATUS_COLORS;
  progressPercentage: number = 0;
  completedChannels: number = 0;
  totalChannels: number = 0;

  constructor(private campaignService: CampaignService) {}

  ngOnInit(): void {
    this.calculateProgress();
  }

  ngOnChanges(): void {
    this.calculateProgress();
  }

  private calculateProgress(): void {
    if (!this.campaign) {
      this.progressPercentage = 0;
      this.completedChannels = 0;
      this.totalChannels = 0;
      return;
    }

    this.progressPercentage = this.campaignService.calculateProgress(this.campaign);
    this.completedChannels = this.campaign.results?.length || 0;
    this.totalChannels = this.campaign.channels?.length || 0;
  }

  isChannelExecuted(channel: string): boolean {
    if (!this.campaign?.results) return false;
    return this.campaign.results.some((r: any) => r.channel === channel);
  }

  getChannelResult(channel: string): any {
    if (!this.campaign?.results) return null;
    return this.campaign.results.find((r: any) => r.channel === channel);
  }

  hasResults(): boolean {
    return !!(this.campaign?.results && this.campaign.results.length > 0);
  }

  getChannelIcon(channel: string): string {
    const icons: Record<string, string> = {
      'EMAIL': this.channelIcons.EMAIL,
      'SMS': this.channelIcons.SMS,
      'WHATSAPP': this.channelIcons.WHATSAPP,
      'CALL': this.channelIcons.CALL
    };
    return icons[channel] || 'fa-solid fa-envelope';
  }

  getResultStatusColor(success: boolean, error?: string): string {
    if (success) return '#28a745'; // Success
    if (error) return '#dc3545'; // Failed
    return '#ffc107'; // Pending
  }

  getResultStatusLabel(success: boolean, error?: string): string {
    if (success) return 'Exitoso';
    if (error) return 'Fallido';
    return 'Pendiente';
  }
}
